// reducers/demoSessionReducer.js
import {
    FETCH_EXISTING_DEMO_SESSION_REQUEST,
    FETCH_EXISTING_DEMO_SESSION_FAILURE,
    FETCH_EXISTING_DEMO_SESSION_SUCCESS,
    CLEAR_EXISTING_DEMO_SESSION,
} from '../../../../Constants/actionTypes';

const initialState = {
    loading: false,
    demoSession: null,
    error: null,
};

const FetchExistingDemoSessionReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_EXISTING_DEMO_SESSION_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case FETCH_EXISTING_DEMO_SESSION_SUCCESS:
            return {
                ...state,
                loading: false,
                demoSession: action.payload,
            };
        case FETCH_EXISTING_DEMO_SESSION_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case CLEAR_EXISTING_DEMO_SESSION:
            return {
                ...initialState, // Reset to initial state
            };
        default:
            return state;
    }
};


export default FetchExistingDemoSessionReducer;
